import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type { ServiceRequest } from "@curai/js-fhir-tools";

export enum OrderingUnavailableReason {
  SONORA = "SONORA",
}

export const ORDERING_UNAVAILABLE_REASON_LABELS: Record<
  OrderingUnavailableReason,
  string
> = {
  [OrderingUnavailableReason.SONORA]:
    "Orders cannot be placed electronically to Sonora Quest locations.",
};

export interface PSCLocation {
  locationId: string;
  compendiumId: string;
  name: string;
  phone?: string;
  fax?: string;
  address?: string[];
  city?: string;
  state?: string;
  zip?: string;
  longitude?: number;
  latitude?: number;
  businessUnitName?: string;
  orderingUnavailableReason?: OrderingUnavailableReason;
}

interface PSCLocationSearchResponse {
  pscs: PSCLocation[];
}

export interface PSCLocationSearchParams {
  labNetwork: (typeof ServiceRequest.LAB_NETWORKS)[keyof typeof ServiceRequest.LAB_NETWORKS];
  city?: string;
  state?: string;
  zip?: string;
}

export const useSearchLabPSCLocations = ({
  labNetwork,
  city,
  state,
  zip,
}: PSCLocationSearchParams) => {
  return useApi<PSCLocationSearchResponse>({
    queryOptions: {
      enabled: Boolean(labNetwork) && (Boolean(state) || Boolean(zip)),
      queryFn: async () => {
        const response = await axiosInstance.get<PSCLocationSearchResponse>(
          "/labs/locations/psc/search",
          { params: { labNetwork, city, state, zip } },
        );

        return response.data;
      },
      queryKey: QueryKeys.Labs.SEARCH_PSC_LOCATIONS({
        labNetwork,
        city,
        state,
        zip,
      }),
    },
  });
};
